/* SUN365 cart page (sections/sun-cart.liquid).
   Quantity, remove and discount changes go through the Ajax Cart API with
   bundled section rendering, then only the [data-s365c-swap] regions are
   replaced. The express checkout buttons are never re-rendered. Without
   JavaScript the page still works: the Update button submits the cart form,
   Remove follows its url_to_remove link, add-ons post to /cart/add. */
(function () {
  "use strict";

  var busy = false;
  var queue = {};    /* line key -> latest quantity asked for while a request was in flight */
  var noteTimer = null;

  function root() { return document.querySelector("[data-s365c]"); }

  function setBusy(r, on) {
    busy = on;
    r.classList.toggle("is-busy", on);
    r.setAttribute("aria-busy", on ? "true" : "false");
  }

  function announce(r, text) {
    var el = r.querySelector("[data-s365c-live]");
    if (!el || !text) return;
    el.textContent = "";
    window.setTimeout(function () { el.textContent = text; }, 60);
  }

  function showError(r, text) {
    var el = r.querySelector("[data-s365c-error]");
    if (!el) return;
    el.textContent = text || "";
    el.hidden = !el.textContent;
  }

  /* The store's own message only for a stock limit (422); anything else is
     technical, so show ours. */
  function fail(r, err) {
    var own = err && err.status === 422 && err.userMessage;
    showError(r, own || r.getAttribute("data-error") || "");
  }

  /* The sticky checkout bar cannot stay inside #MainContent: the theme
     transforms it, which turns position: fixed into absolute. It goes right
     after main, so screen readers still reach it before the footer. */
  function homeBar(r) {
    var bar = r.querySelector("[data-s365c-bar]");
    if (!bar) return;
    document.querySelectorAll("[data-s365c-bar]").forEach(function (old) {
      if (old !== bar) old.remove();
    });
    var main = document.getElementById("MainContent");
    if (main && main.parentNode && main.contains(bar)) main.parentNode.insertBefore(bar, main.nextSibling);
    else if (!main && bar.parentNode !== document.body) document.body.appendChild(bar);
  }

  /* On one-column layouts the express buttons sit right under the line items.
     Move the node itself (never a copy) so tab order follows what is seen. */
  function placeExpress(r) {
    var express = r.querySelector("[data-s365c-express]");
    var slotMain = r.querySelector("[data-s365c-express-slot]");
    var slotSide = r.querySelector("[data-s365c-express-home]");
    var grid = r.querySelector(".s365c__grid");
    if (!express || !slotMain || !slotSide || !grid) return;
    var oneColumn = window.getComputedStyle(grid).display === "flex";
    var target = oneColumn ? slotMain : slotSide;
    if (express.parentNode !== target) target.appendChild(express);
  }

  function focusTarget(r, id) {
    if (!id) return null;
    if (id === "title") return r.querySelector("[data-s365c-title]");
    return r.querySelector('[data-s365c-focus="' + id + '"]');
  }

  function swapFrom(r, html, fallbackFocus) {
    var doc = new DOMParser().parseFromString(html, "text/html");
    if (!doc.querySelector("[data-s365c]")) return false;

    /* Remember where focus is. Only take it back if the swap removes it. */
    var active = document.activeElement;
    var activeId = active && active.getAttribute ? active.getAttribute("data-s365c-focus") : null;
    var inSwap = !!(active && active.closest && active.closest("[data-s365c-swap]"));
    var typing = inSwap && active.classList && active.classList.contains("s365c__qty-input") &&
      active.value !== active.defaultValue && active.value !== active.getAttribute("data-s365c-sent")
      ? active.value : null;

    document.querySelectorAll("[data-s365c-swap]").forEach(function (el) {
      var key = el.getAttribute("data-s365c-swap");
      var fresh = doc.querySelector('[data-s365c-swap="' + key + '"]');
      if (fresh) el.replaceWith(document.importNode(fresh, true));
    });

    if (inSwap || active === document.body || (active && !document.contains(active))) {
      var el = focusTarget(r, activeId) || focusTarget(r, fallbackFocus) || r.querySelector("[data-s365c-title]");
      if (el) {
        el.focus({ preventScroll: true });
        /* Keep what the customer was still typing in another row. */
        if (typing !== null && el.classList.contains("s365c__qty-input")) el.value = typing;
      }
    }
    return true;
  }

  function cartUrl(r, attr) {
    return (r.getAttribute(attr) || "").replace(/\/$/, "") + ".js";
  }

  function post(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok) {
          var err = new Error(json && (json.description || json.message) || "Cart error");
          err.status = res.status;
          err.userMessage = json && json.description;
          throw err;
        }
        return json;
      });
    });
  }

  function withSections(r, body) {
    body.sections = [r.getAttribute("data-section")];
    body.sections_url = window.location.pathname;
    return body;
  }

  function afterRender(r, json, focusId, quiet) {
    if (json.item_count === 0) { window.location.reload(); return false; }
    var html = json.sections && json.sections[r.getAttribute("data-section")];
    if (!html || !swapFrom(r, html, focusId)) { window.location.reload(); return false; }
    showError(r, "");
    if (!quiet) {
      var total = r.querySelector("[data-s365c-total]");
      var free = r.querySelector(".s365c__free-title");
      var msg = (r.getAttribute("data-updated") || "").replace("[total]", total ? total.textContent.trim() : "");
      announce(r, [msg, free ? free.textContent.trim() : ""].filter(Boolean).join(". "));
    }
    return true;
  }

  function serverQty(r, key) {
    var input = r.querySelector('.s365c__qty-input[data-key="' + key + '"]');
    return input ? parseInt(input.defaultValue, 10) : null;
  }

  /* One cart request at a time. Changes made meanwhile are kept per line and
     sent afterwards, so no tap is lost and an older response never lands
     after a newer one. */
  function change(r, key, qty, focusId) {
    if (!key) return;
    var field = r.querySelector('.s365c__qty-input[data-key="' + key + '"]');
    if (field) field.setAttribute("data-s365c-sent", String(qty));
    if (busy) {
      queue[key] = { qty: qty, focusId: focusId, variant: field ? field.getAttribute("data-variant") : null };
      return;
    }
    setBusy(r, true);
    post(cartUrl(r, "data-change-url"), withSections(r, { id: key, quantity: qty }))
      .then(function (json) { afterRender(r, json, qty === 0 ? "title" : focusId, false); })
      .catch(function (err) {
        fail(r, err);
        return refresh(r);
      })
      .finally(function () {
        setBusy(r, false);
        drain(r);
      });
  }

  /* A line's key changes when its discounts change, so a change queued during
     a discount update may name a key that is gone. Find the line again by its
     variant when that is unambiguous. */
  function currentKey(r, key, variant) {
    if (r.querySelector('.s365c__qty-input[data-key="' + key + '"]')) return key;
    if (!variant) return null;
    var same = r.querySelectorAll('.s365c__qty-input[data-variant="' + variant + '"]');
    return same.length === 1 ? same[0].getAttribute("data-key") : null;
  }

  function drain(r) {
    var keys = Object.keys(queue);
    while (keys.length) {
      var k = keys.shift();
      var job = queue[k];
      delete queue[k];
      var live = currentKey(r, k, job.variant);
      if (live && serverQty(r, live) !== job.qty) {
        var focusId = job.focusId && job.focusId.indexOf(k) !== -1 ? job.focusId.replace(k, live) : job.focusId;
        change(r, live, job.qty, focusId);
        return;
      }
    }
  }

  /* Re-render without changing anything, to put inputs back in sync after an
     error. Returned so the caller stays busy until it has landed. */
  function refresh(r) {
    var url = window.location.pathname + "?section_id=" + encodeURIComponent(r.getAttribute("data-section"));
    return fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) { swapFrom(r, html, null); })
      .catch(function () {});
  }

  /* Discount codes come from /cart.js: a code Shopify accepts but cannot show
     in the cart yet (free shipping) is not among the rendered applications. */
  function cartCodes() {
    var url = window.location.pathname.replace(/\/cart\/?$/, "/cart") + ".js";
    return fetch(url, { headers: { Accept: "application/json" } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        return (cart.discount_codes || []).map(function (c) { return c.code; });
      });
  }

  function sameCode(a, b) { return String(a).toLowerCase() === String(b).toLowerCase(); }

  function setCodes(r, codes) {
    return post(cartUrl(r, "data-update-url"), withSections(r, { discount: codes.join(",") }));
  }

  function applyCode(r, form) {
    var input = form.querySelector("input");
    var msgEl = form.querySelector("[data-s365c-code-msg]");
    var code = (input.value || "").trim();
    if (!code || busy) return;
    function message(text, isError) {
      msgEl.textContent = text || "";
      msgEl.hidden = !msgEl.textContent;
      msgEl.classList.toggle("is-info", !isError);
      if (isError) input.setAttribute("aria-invalid", "true");
      else input.removeAttribute("aria-invalid");
    }
    setBusy(r, true);
    var before = [];
    cartCodes()
      .then(function (codes) {
        before = codes;
        if (before.some(function (c) { return sameCode(c, code); })) { input.value = ""; return null; }
        return setCodes(r, before.concat([code])).then(function (json) {
          var list = json.discount_codes || [];
          var entry = list.filter(function (c) { return sameCode(c.code, code); })[0];
          if (!entry || entry.applicable === false) {
            /* Shopify keeps an inapplicable code on the cart; put the list back. */
            return setCodes(r, before).then(function (j) {
              afterRender(r, j, null, true);
              message(r.getAttribute("data-invalid"), true);
              if (document.activeElement === document.body || document.activeElement === input) input.focus();
            });
          }
          afterRender(r, json, null, false);
          input.value = "";
          var holder = r.querySelector("[data-codes]");
          var shown = (holder ? holder.getAttribute("data-codes") : "").split(",")
            .some(function (c) { return sameCode(c.trim(), code); });
          message(shown ? "" : r.getAttribute("data-code-later"), false);
          return null;
        });
      })
      .catch(function (err) { fail(r, err); })
      .finally(function () { setBusy(r, false); drain(r); });
  }

  function removeCode(r, code, chip) {
    if (busy) return;
    var chips = Array.prototype.slice.call(r.querySelectorAll("[data-s365c-uncode]"));
    var idx = chips.indexOf(chip);
    var neighbour = chips[idx + 1] || chips[idx - 1];
    var nextCode = neighbour ? neighbour.getAttribute("data-s365c-uncode") : null;
    setBusy(r, true);
    cartCodes()
      .then(function (codes) {
        return setCodes(r, codes.filter(function (c) { return !sameCode(c, code); }));
      })
      .then(function (json) {
        var hadFocus = document.activeElement === chip;
        afterRender(r, json, null, false);
        if (!hadFocus && document.activeElement !== document.body) return;
        var target = null;
        if (nextCode) {
          r.querySelectorAll("[data-s365c-uncode]").forEach(function (c) {
            if (!target && sameCode(c.getAttribute("data-s365c-uncode"), nextCode)) target = c;
          });
        }
        if (!target) target = r.querySelector('[data-s365c-focus="disc-toggle"]');
        if (target) target.focus({ preventScroll: true });
      })
      .catch(function (err) { fail(r, err); })
      .finally(function () { setBusy(r, false); drain(r); });
  }

  function saveNote(r, value) {
    window.clearTimeout(noteTimer);
    noteTimer = window.setTimeout(function () {
      post(cartUrl(r, "data-update-url"), { note: value }).catch(function () {});
    }, 400);
  }

  function commitQty(r, input) {
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) { input.value = input.defaultValue; return; }
    var key = input.getAttribute("data-key");
    if (qty === parseInt(input.defaultValue, 10) && !queue[key]) return;
    change(r, key, qty, input.getAttribute("data-s365c-focus"));
  }

  document.addEventListener("click", function (e) {
    var r = root();
    if (!r) return;

    var step = e.target.closest("[data-s365c-step]");
    if (step && r.contains(step)) {
      var item = step.closest(".s365c__item");
      var input = item && item.querySelector(".s365c__qty-input");
      if (!input) return;
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute("data-s365c-step"), 10));
      input.value = next;
      change(r, input.getAttribute("data-key"), next, step.getAttribute("data-s365c-focus"));
      return;
    }

    var remove = e.target.closest("[data-s365c-remove]");
    if (remove && r.contains(remove)) {
      e.preventDefault();
      change(r, remove.getAttribute("data-key"), 0, "title");
      return;
    }

    var toggle = e.target.closest("[data-s365c-toggle]");
    if (toggle && r.contains(toggle)) {
      var panel = document.getElementById(toggle.getAttribute("aria-controls"));
      if (!panel) return;
      var open = toggle.getAttribute("aria-expanded") !== "true";
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      panel.hidden = !open;
      if (open) {
        var field = panel.querySelector("input, textarea");
        if (field) field.focus();
      }
      return;
    }

    var chip = e.target.closest("[data-s365c-uncode]");
    if (chip && r.contains(chip)) removeCode(r, chip.getAttribute("data-s365c-uncode"), chip);
  });

  document.addEventListener("change", function (e) {
    var r = root();
    var input = e.target.closest && e.target.closest(".s365c__qty-input");
    if (!r || !input || !r.contains(input)) return;
    commitQty(r, input);
  });

  document.addEventListener("input", function (e) {
    var r = root();
    if (r && e.target.matches && e.target.matches("[data-s365c-note]")) saveNote(r, e.target.value);
  });

  document.addEventListener("submit", function (e) {
    var r = root();
    if (!r) return;
    var form = e.target;
    if (form.matches("[data-s365c-discount]")) {
      e.preventDefault();
      applyCode(r, form);
      return;
    }
    /* Enter in a quantity field submits the cart form through its default
       (Update) button. With JavaScript, update in place instead; if the
       browser's own change event already sent it, commitQty skips it. */
    if (form.id === "cart" && r.contains(form) && e.submitter && e.submitter.name === "update") {
      e.preventDefault();
      var input = document.activeElement && document.activeElement.closest && document.activeElement.closest(".s365c__qty-input");
      if (input) commitQty(r, input);
    }
  });

  var resizeTimer = null;
  window.addEventListener("resize", function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () { var r = root(); if (r) placeExpress(r); }, 150);
  });

  function init() {
    var r = root();
    if (!r) return;
    r.classList.add("has-js");
    homeBar(r);
    placeExpress(r);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:section:unload", function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector("[data-s365c]")) {
      document.querySelectorAll("[data-s365c-bar]").forEach(function (b) { b.remove(); });
    }
  });
})();
